interface ModalFooterProps {
    modalFooterClass?: string
    children?: any
}

export const ModalFooter = ({
    modalFooterClass="",
    children
}: ModalFooterProps) => {
    return (
        <div className={`modal-footer flex items-center justify-end px-4 py-2 border-t border-solid border-blueGray-200 rounded-b  ${modalFooterClass}`}>
            {children}
        </div>
    )
}
